import { can } from "@/permissions/"

/**
 * @param {*} status - status of claim
 * Special case for asia where editing requires status of Claim
 * Also, only certain people can edit once Claim is approved
 */
export const canEditApprovedClaims = status => {
	if (status !== "APPROVED") return can("writeClaims")
	if (status === "APPROVED") return can("writeClaimWhenStatusApproved")
}